import { useCallback, useState } from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { SerializedError } from '@reduxjs/toolkit';
import { Commitment, CommitmentActionTypes } from 'types/';
// import { getNewRelicAgent } from './useNewRelic';

// Create a singleton instance to store the result data across components
let commitmentResultData:
  | { data: Commitment<CommitmentActionTypes> }
  | { error: FetchBaseQueryError | SerializedError }
  | undefined;

/**
 * Hook for storing and accessing commitment result data across components
 * Similar to useCommitmentTimeData but stores the entire result object
 */
export const useCommitmentResultData = () => {
  // Get the current value
  const [resultCommitmentData, setResultCommitmentData] =
    useState<typeof commitmentResultData>(commitmentResultData);

  // Update both the local state and the singleton value
  const updateCommitmentResultData = useCallback(
    (newResultData?: typeof commitmentResultData) => {
      // Update singleton value
      commitmentResultData = newResultData;

      // Update local state
      setResultCommitmentData(newResultData);
    },
    []
  );

  // Extract and store the entire result data
  const extractCommitmentResultData = useCallback(
    <Type extends CommitmentActionTypes, T extends Commitment<Type>>(
      result: { data: T } | { error: FetchBaseQueryError | SerializedError }
    ) => {
      // Update the result data
      updateCommitmentResultData(result as typeof commitmentResultData);

      // Send commitment ID information to New Relic if data exists
      // if ('data' in result && result.data?.commitment_id) {
      //   getNewRelicAgent()
      //     .then((newrelic) => {
      //       if (newrelic?.setCustomAttribute) {
      //         // Set commitment ID as custom attribute for New Relic tracking
      //         newrelic.setCustomAttribute(
      //           'commitmentId',
      //           result.data.commitment_id
      //         );
      //
      //         // Optionally set additional commitment metadata
      //         if (result.data.action?.type) {
      //           newrelic.setCustomAttribute(
      //             'commitmentActionType',
      //             result.data.action.type
      //           );
      //
      //           // Save profiler ID if action data contains profiler information
      //           if (
      //             result.data.action.data &&
      //             'profiler' in result.data.action.data
      //           ) {
      //             newrelic.setCustomAttribute(
      //               'profilerId',
      //               result.data.action.data.profiler.id
      //             );
      //           }
      //         }
      //       }
      //     })
      //     .catch((error) => {
      //       // Silently handle New Relic errors to avoid disrupting the main flow
      //       // eslint-disable-next-line no-console
      //       console.debug('New Relic tracking error:', error);
      //     });
      // }

      return result;
    },
    [updateCommitmentResultData]
  );

  return {
    resultCommitmentData,
    updateCommitmentResultData,
    extractCommitmentResultData,
  };
};
